<template>
  <div class="ContractStatus">
    <span class="label">{{dataInfo.label}}</span>
    <span class="value">{{moneyFormat(dataInfo.value, dataInfo.moneyFormat)}}</span>
  </div>
</template>
<script>
import { toThousands } from '@/utils/index';

export default {
  props: {
    dataInfo: {},
  },
  methods: {
    moneyFormat(value, flag) {
      return flag ? toThousands(value) : value;
    },
  },
};
</script>
<style lang="scss" scoped>
.ContractStatus {
  margin-top: 50px;
  .label {
    padding-right: 20px;
    color: #a6a6a6;
  }
  .value {
    color: #ff6538;
  }
}
</style>
